import {
  AdvancedMarker,
  GoogleMapsContext,
  latLngEquals,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { forwardRef, useContext, useEffect, useMemo, useState } from "react";
import tragetMarkerIcon from "../assets/targetMarker.svg";
import { OnDemandContext } from "../context";

export const RadiusMarker = forwardRef(({ ...props }, ref) => {
  const maps = useMapsLibrary("maps");
  const map = useContext(GoogleMapsContext)?.map;
  const { startingPoint, areaRadius } = useContext(OnDemandContext);

  const [center, setCenter] = useState(props.position);

  const circle = useMemo(() => {
    if (!maps) return null;

    return new maps.Circle({
      fillColor: "rgba(0, 122, 255, 0.2)",
      strokeColor: "rgb(0, 122, 255)",
      strokeWeight: 1,
      clickable: false,
    });
  }, [maps]);

  useEffect(() => {
    setCenter(startingPoint);
  }, [startingPoint]);

  // Update sets & removes circle off the map
  useEffect(() => {
    if (!map || !circle) return;

    circle.setMap(map);

    return () => {
      circle.setMap(null);
    };
  }, [circle, map]);

  // Update circle's center
  useEffect(() => {
    if (!circle) return;

    if (!latLngEquals(center, circle.getCenter())) {
      circle.setCenter(center);
    }
  }, [center, circle]);

  // Update circle's radius
  useEffect(() => {
    if (!circle) return;

    if (areaRadius !== circle.getRadius()) {
      circle.setRadius(areaRadius);
    }
  }, [circle, areaRadius]);

  const handleDrag = e => {
    setCenter({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    if (props.onDrag) props.onDrag();
  };

  return (
    <AdvancedMarker
      position={startingPoint}
      {...props}
      ref={ref}
      anchorPoint={["50%", "14px"]}
      onDrag={handleDrag}
    >
      <img width={42} src={tragetMarkerIcon} />
    </AdvancedMarker>
  );
});
